import { render } from "./SalesChannelsView.vue?vue&type=template&id=17aa1f62"
import script from "./SalesChannelsView.vue?vue&type=script&lang=js"
export * from "./SalesChannelsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__